import base64Service from './base64Service';

export default {
  dataURI(html) {
    if (html) {
      const data = base64Service.b64EncodeUnicode(html);
      return `data:text/html;charset=utf-8;base64,${data}`;
    }
    return null;
  },
  /**
   * MLD-7816
   * @see https://claude.ai/chat/2d68a2c9-a478-4938-b3f1-02cfba8d097d
   * @param html
   * @returns {string}
   */
  addOverlayToHTML(html) {
    const overlayDiv = '<div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0, 0, 0, 0); z-index: 9999;"></div>';

    // First, add position: relative to the body tag
    html = html.replace(
      /<body([^>]*)>/i,
      (match, attributes) => {
        // Check if style attribute already exists
        if (attributes.includes('style=')) {
          // Add to existing style
          return match.replace(/style="([^"]*)"/, 'style="$1; position: relative;"');
        } else {
          // Add new style attribute
          return `<body${attributes} style="position: relative;">`;
        }
      }
    );

    // Then inject the overlay before </body>
    const bodyCloseIndex = html.lastIndexOf('</body>');
    if (bodyCloseIndex !== -1) {
      return html.substring(0, bodyCloseIndex) +
        overlayDiv +
        html.substring(bodyCloseIndex);
    }

    return html + overlayDiv;
  },
}
